import { CEO_THEMES } from "./ceoThemes";
import { useCEOTheme } from "./CEOThemeProvider";

export default function CEOThemeSwitcher() {
  const { theme, setTheme } = useCEOTheme();
  return (
    <fieldset className="ceo-theme-picker">
      <legend>Appearance</legend>
      <div className="ceo-theme-picker__options">
        {CEO_THEMES.map((option) => (
          <label key={option.id} className="ceo-theme-option">
            <input
              type="radio"
              name="ceo-theme"
              value={option.id}
              checked={theme === option.id}
              onChange={() => setTheme(option.id)}
            />
            <span className={`ceo-theme-option__swatch ceo-theme-option__swatch--${option.id}`} aria-hidden="true" />
            <span className="ceo-theme-option__copy">
              <strong>{option.label}</strong>
              <small>{option.description}</small>
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
